import React, { useContext, type ReactElement } from "react";
import ReactMarkdown from "react-markdown";

import { useTranslations } from "@rootreeweb/react-translations";
import { Heading2 } from "@rootreeweb/ui";

import { appContext } from "../shared/AppContextProvider.js";
import type { PouchType } from "../types.js";
import Table from "./Table.js";

type Props = {
	pouch: PouchType;
};

/**
 *
 *
 * @param props The props for the component.
 * @returns The component.
 */
export default function Category(props: Props): ReactElement {
	const { pouch } = props;
	const { getTranslation } = useTranslations();
	const { getLocalizedField } = useContext(appContext);
	return (
		<div className="dl:mb-8 dl:overflow-hidden">
			<Heading2 className="dl:text-center">
				{getLocalizedField(pouch, "pouchType")}{" "}
				{getTranslation("core-size-fill-amounts")}
			</Heading2>
			<div className="dl:max-w-full dl:overflow-auto dl:text-center">
				<ReactMarkdown>{getLocalizedField(pouch, "description")}</ReactMarkdown>
			</div>
			<div className="dl:max-w-full dl:overflow-auto">
				<Table pouch={pouch} />
			</div>
		</div>
	);
}
